/* eslint-disable no-console */
import React from 'react';

import {
  CrewSettlementDetails,
  WorkerSettlementDetails,
} from '@/modules/Settlements';
import { useStore } from '@/shared/hooks/context/createGenericContext';

function SettlementDetails() {
  const [selectedAsset] = useStore((store) => store?.asset);

  return selectedAsset?.settlementLevel === 2 ? (
    <WorkerSettlementDetails />
  ) : (
    <CrewSettlementDetails />
  );
}
export { SettlementDetails };
